import { defaults } from 'lodash-es'
import { createElement } from 'react'
import { toast } from 'react-toastify'
import { UIDialog } from 'src/components/ui/Modal'
import Text from 'src/components/ui/Text'
import { executeDeleteArtwork } from '../apollo/artwork'

export * from './artworkApiParamsPacker'
export * from './artworkParamsExtractor'

/**
 * Delete an artwork
 *
 * @returns The operation result
 *   - `true`: The operation was successful
 *   - `false`: Error occurred during the operation
 *   - `undefined`: The operation was cancelled
 */
export async function deleteArtwork(
  artworkId: string,
  opts?: {
    /** Skip confirmation (like `--quiet`) */
    skipConfirm?: boolean
    dialogProps?: Parameters<typeof UIDialog.confirm>[0]
  },
) {
  const toProceed =
    opts?.skipConfirm ||
    (await UIDialog.confirm(
      defaults(opts?.dialogProps, {
        heading: createElement(Text, {
          i18nKey: 'artwork:delete-artwork.confirm.title',
        }),
        content: createElement(Text, {
          i18nKey: 'artwork:delete-artwork.confirm.content',
          values: { count: 1 },
        }),
        confirmProps: {
          children: createElement(Text, { i18nKey: 'action:delete.label' }),
          color: 'danger',
        },
      }),
    ))

  if (toProceed) {
    try {
      await executeDeleteArtwork({ id: artworkId })
      toast.success(
        createElement(Text, {
          i18nKey: 'user:collection.notice.delete.success',
        }),
      )
      return true
    } catch (err) {
      toast.error(
        createElement(
          'p',
          null,
          createElement(Text, {
            i18nKey: 'user:collection.notice.delete.failed',
          }),
          ` (${String(err)})`,
        ),
      )
      return false
    }
  }
}
